<template>
  <div>
    <dialog-reset
      v-loading="loading"
      slotShow
      height="65vh"
      width="1150px"
      top="10vh"
      title="查看详情"
      :visible.sync="show"
    >
      <avue-form :option="optionForm" ref="form" v-model="formData"></avue-form>
      <FormTable
        ref="formTable"
        :formData="formData"
        :optionConfig="optionConfig"
      />
    </dialog-reset>
  </div>
</template>

<script>
import { getDetail } from "../api";
export default {
  data() {
    return {
      show: false,
      loading: false,
      formData: {
        list: [],
      },
      optionForm: {
        ...this.$store.state.formOption,
        submitBtn: false,
        emptyBtn: false,
        disabled: true,
        column: [
          {
            label: "货主",
            prop: "custNo",
            type: "select",
            dicUrl: "/api/produce/blade-dept/select/distinct/select",
            props: {
              label: "deptName",
              value: "id",
            },
          },
          {
            label: "车次编号",
            prop: "trainNumber",
          },
          {
            label: "车厢数",
            prop: "carriageCount",
            type: "number",
            min: 1,
            max: 99999,
          },
          {
            label: "总重量(吨)",
            prop: "totalWeight",
            type: "number",
            precision: 2,
            min: 0.01,
            max: 99999,
          },
          {
            label: "到达时间",
            prop: "trainArrivalTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
          },
          {
            label: "发车时间",
            prop: "trainDepartTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
          },
        ],
      },
      // 子表展示配置（详情用）
      optionConfig: {
        columnType: "view",
        column: [
          {
            label: "车厢编号",
            prop: "carriageNumber",
            type: "input",
          },
          {
            label: "物资名称",
            prop: "cargoName",
            // 使用字典配置以便展示名称
            type: "select",
            remote: true,
            dicUrl:
              "/api/produce/vardict/select/distinct/pycode?cargoName={{key}}",
            props: {
              label: "cargoName",
              value: "id",
            },
          },
          // {
          //   label: "车厢数",
          //   prop: "carriageCount",
          //   type: "number",
          // },
          {
            label: "总重量(吨)",
            prop: "totalWeight",
            type: "custom-input",
            precision: 2,
          },
        ],
      },
    };
  },
  methods: {
    //打开
    open(id) {
      this.show = true;
      this.formData = { list: [] };
      this.loading = true;
      getDetail(id).then((res) => {
        this.formData = res.data.data;
        if (!this.formData.list) {
          this.formData.list = [];
        }
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped lang="scss"></style>
